<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span @click="signOut" style="color:#fff">{{
                    $t('welcome.signOut')
                }}</span>
            </div>
            <div>
                <div class="mainTitle">{{ $t('guest.title') }}</div>
                <div class="mainContent mainBody">
                    <div @click="path('signin')" width="50%">
                        <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/10.png" alt="">
                        <p>{{ $t('guest.menu1') }}</p>
                    </div>
                    <div @click="path('face')" width="50%">
                        <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/11.png" alt="">
                        <p>{{ $t('guest.menu2') }}</p>
                    </div>
                    <div @click="path('earphone')" width="50%">
                        <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/12.png" alt="">
                        <p>{{ $t('guest.menu3') }}</p>
                    </div>
                    <div @click="path('hotel')" width="50%">
                        <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/13.png" alt="">
                        <p>{{ $t('guest.menu4') }}</p>
                    </div>
                    <div @click="path('out')" width="50%"
                        :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.3rem' }">
                        <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/14.png" alt="">
                        <p>{{ $t('guest.menu5') }}</p>
                    </div>
                    <div @click="path('out1')" width="50%">
                        <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/15.png" alt="">
                        <p>{{ $t('guest.menu6') }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="back" @click="path('menu')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }">
            <img width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div>
    </div>
</template>
<script>
import menus from "../components/menu.vue"
export default {
    components: {
        menus
    },
    name: "menuView",
    data() {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),

        }
    },
    created() {
        //_hmt.push(['_trackPageview', '/guest']);
    },
    mounted() {
        // this.alerts3("<p style='text-align:left;'>" + this.$t('tips.tips3') + "</p>");
    },
    methods: {
        alerts3(content) {
            layer.open({
                title: [
                    this.$t('tips.tips1'),
                    'background-color: #c61533; color:#fff;'
                ],
                content: content,
                btn: this.$t('tips.tips2'),
                yes: function (index) {
                    layer.closeAll();
                }
            });
        },
        signOut() {
            localStorage.clear();
            this.$router.replace('/login');
        },
        path(path) {
            this.$router.replace('/' + path)
        }
    }
}
</script>
<style scoped>
.mainContent {
    width: 6rem;
    margin: 0 auto;
    color: #fff;
    font-size: .29rem;
    font-weight: 600;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

}

.mainContent>div {
    width: 2.57rem;
    height: 1.6rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-size: 100%;
    text-shadow: 0px .04rem .04rem rgba(17, 107, 103, 0.51);
    border-bottom: 1px solid #fff;
}

.mainContent>div:nth-child(5),
.mainContent>div:nth-child(6) {
    border-bottom: none;
}

.mainContent>div:nth-child(even) {
    position: relative;
}

.mainContent>div:nth-child(even)::after {
    content: '';
    width: 1px;
    height: 1.2rem;
    background-color: #fff;
    position: absolute;
    left: -.22rem;
    top: 50%;
    transform: translateY(-50%);
}

.mainContent>div>img {
    width: 0.75rem;
    margin-bottom: .1rem;
}
</style>


// WEBPACK FOOTER //
// src/views/guest.vue